import operationColumnService from "@/services/operations/operationColumnService";
import operationLocalDbService from "@/services/operations/operationLocalDbService";
import mapKeys from "lodash/mapKeys";
import groupBy from "lodash/groupBy";

const INITIAL_STATE = {
  operationColumns: [
    // {
    //   "ao_enterprise_column_form_version_items": [
    //     {
    //       "ao_enterprise_column_id": "string",
    //       "form_version_item_id": "string",
    //       "id": "string"
    //     }
    //   ],
    //   "ao_enterprise_id": "string",
    //   "id": "string",
    //   "min_width": 0,
    //   "name": "string",
    //   "sort_order": 0
    // }
  ],
};

export default {
  isRegistered: false,
  namespaced: true,
  state: {
    ...INITIAL_STATE,
  },
  mutations: {
    /**
     * operation column 設定をセットするミューテーション
     *
     * @param {Object} state - Vuex ストアの状態オブジェクト
     * @param {OperationColumn[]} data - データ
     * @returns {void}
     */
    SET_OPERATION_COLUMNS(state, data) {
      state.operationColumns = data;
    },

    RESET_STATE(state) {
      Object.assign(state, INITIAL_STATE);
    },
  },
  actions: {
    /**
     * operation column 設定 を storeにセットする
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationColumns({ commit }) {
      const response = await operationColumnService.getOperationColumns();
      const operationColumns = response.data || [];
      commit("SET_OPERATION_COLUMNS", operationColumns);
      operationLocalDbService.setOperationColumnsToLocalDB(operationColumns);
    },

    /**
     * operation column 設定  を localDB から取得し storeにセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationColumnsFromLocalDB({ commit }) {
      const operationColumns = await operationLocalDbService.getOperationColumnsFromLocalDB();
      commit("SET_OPERATION_COLUMNS", operationColumns || []);
    },

    /**
     * operation column  を localDB から取得し storeにセットする
     * localDBにない場合はAPIから取得し store にセットする
     *
     * @returns {Promise<void>}
     * @throws {Error}
     */
    async setOperationColumnsFromLocalDBAndAPI({ dispatch, getters }) {
      await dispatch("setOperationColumnsFromLocalDB");
      if (!getters.hasOperationColumns) {
        dispatch("setOperationColumns");
      }
    },

    /**
     * storeを初期値に戻す
     *
     * @param {Object} context - The Vuex store context object
     * @param {Function} context.commit - The commit function
     * @returns {Promise<void>}
     */
    async resetState({ commit }) {
      commit("RESET_STATE");
    },
  },
  getters: {
    // OperationColumn[]
    validOperationColumns({ operationColumns }) {
      return operationColumnService.validOperationColumns(operationColumns);
    },

    /**
     * Maps valid operation columns by ao_operation_id.
     *
     * @param {Object} _state - The state object.
     * @param {OperationColumn[]} validOperationColumns - The array of valid operation columns.
     * @returns {Object} - The mapped operation columns by ao_operation_id.
     */
    /**
       指定した ao_enterprise_id が追加カラムを持っているか判定するのに使う
     * Groups the valid operation columns by the "ao_enterprise_id" property.
     *
     * @param {Object} _state - The state object.
     * @param {OperationColumn[]} validOperationColumns - The array of valid operation columns.
     * @returns {{ [key: OperationColumn["ao_enterprise_id"]]: OperationColumn[] }} - The object with operation columns grouped by "ao_enterprise_id".
     */
    operationColumnGroupByAoEnterpriseId(_state, { validOperationColumns }) {
      return groupBy(validOperationColumns, "ao_enterprise_id");
    },

    aoEnterpriseColumnFormVersionItems(_, { validOperationColumns }) {
      return validOperationColumns
        .map(oc => oc.ao_enterprise_column_form_version_items)
        .flat()
        .filter(ci => operationColumnService.isValidColumnItem(ci));
    },

    aoEnterpriseColumnFormVersionItemsGroupByAoEnterpriseColumnId(
      _,
      { aoEnterpriseColumnFormVersionItems }
    ) {
      return groupBy(
        aoEnterpriseColumnFormVersionItems,
        "ao_enterprise_column_id"
      );
    },

    aoEnterpriseColumnFormVersionItemsMapByFormVersionItemId(
      _,
      { aoEnterpriseColumnFormVersionItems }
    ) {
      return mapKeys(
        aoEnterpriseColumnFormVersionItems,
        "form_version_item_id"
      );
    },

    hasOperationColumns(_, { validOperationColumns }) {
      return validOperationColumns.length > 0;
    },
  },
};
